<template>
  <div id="projects" class="bg-dark text-light position-relative">
    <div class="container text-center py-5">
      <h1 class="title">{{ $t('section.projects') }}</h1>
      <hr class="w-25 bg-light mt-1"/>

      <h3>{{ $t('projects.about_my_projects') }}</h3>

      <ul class="nav nav-pills justify-content-center" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="gribTab-tab" data-toggle="tab" href="#gribTab" role="tab" aria-controls="gribTab" aria-selected="true">Grid</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="carouselTab-tab" data-toggle="tab" href="#carouselTab" role="tab" aria-controls="carouselTab" aria-selected="false">Carousel</a>
        </li>
      </ul>

      <div class="tab-content mt-2">
        <div class="tab-pane fade show active" id="gribTab" role="tabpanel" aria-labelledby="gribTab-tab">
          <div class="row">
            <div v-for="(mp, index) in my_projects" :key="`mp-${index}`" class="project col-md-4 mb-2">
              <a :href="mp.url.startsWith('http') ? mp.url : getImgUrl(mp.image)" target="_blank" :title="$t('action.visit')">
                <img :src="getImgUrl(mp.image)" class="img-fluid" />
                <div class="info">
                  <div class="w-100">
                    <h5>{{ mp.title.toUpperCase() }}</h5>
                    <p>{{ $t(mp.description) }}</p>
                  </div>
                  <span v-for="t in mp.technologies" :key="`mpt-${t}-${index}`" class="badge badge-light m-1">{{ t }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="carouselTab" role="tabpanel" aria-labelledby="carouselTab-tab">
          <div id="carouselMP" class="carousel slide mx-auto" data-ride="carousel" style="max-width: 80%;">
            <ol class="carousel-indicators bg-dark-transparent">
              <li v-for="(mp, index) in my_projects" :key="`mp-link-to-slide-${index}`" data-target="#carouselMP" :data-slide-to="index" :class="index === 0 ? 'active' : ''"></li>
            </ol>
            <div class="carousel-inner">
              <div  v-for="(mp, index) in my_projects" :key="`mp-${index}`" :class="`carousel-item  ${index === 0 ? 'active' : ''}`">
                <a :href="mp.url" target="_blank" :title="$t('action.visit')">
                  <img :src="getImgUrl(mp.image)" class="d-block w-100" alt="..." />
                </a>
                <div class="carousel-caption d-none d-md-block bg-dark-transparent">
                  <h5>{{ mp.title.toUpperCase() }}</h5>
                  <p>{{ $t(mp.description) }}</p>
                </div>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carouselMP" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon bg-dark-transparent" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselMP" role="button" data-slide="next">
              <span class="carousel-control-next-icon bg-dark-transparent" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>

    </div>
    <Divider background="light"/>
  </div>
</template>

<script>
import Divider from './Layout/Divider.vue'

export default {
  name: 'projects',
  components: { Divider },
  data: () => ({
    images: null,
    my_projects: [
      { title: 'American Burger', image: 'american-burger.jpg', url: 'https://americanburger.com.co', description: 'projects.american_burger', technologies: ['Wordpress', 'PHP', 'Google Forms', 'MySQL', 'HTML', 'JavaScript', 'CSS'] },
      { title: 'Coderdojo Colombia', image: 'coderdojo.jpg', url: '../assets/images/projects/coderdojo.jpg', description: 'projects.coderdojo', technologies: ['Wordpress', 'PHP', 'Bootstrap', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'easyrt2012', image: 'easyrt2012.jpg', url: 'http://easyrt2012.fr', description: 'projects.easyrt2012', technologies: ['Ruby', 'Ruby on Rails', 'RSpec', 'Bootstrap', 'MongoDB', 'HAML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'Jobprod', image: 'jobprod.jpg', url: 'https://jobprod.com', description: 'projects.jobprod', technologies: ['Wordpress', 'PHP', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'Mon Confort', image: 'mon-confort.jpg', url: 'http://monconfort.senova.fr', description: 'projects.mon_confort', technologies: ['Ruby', 'Ruby on Rails', 'RSpec', 'Bootstrap', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'Quixity', image: 'quixity.jpg', url: 'https://quixity.club', description: 'projects.quixity', technologies: ['Ruby', 'Ruby on Rails', 'Material Design', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'Rappipage', image: 'rappipage.png', url: 'https://rappipage.com', description: 'projects.rappipage', technologies: ['Ruby', 'Ruby on Rails', 'Bootstrap', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery', 'Mailjet'] },
      { title: 'Sigma10', image: 'sigma10.jpg', url: 'https://sigma10.tintosoft.co', description: 'projects.sigma10', technologies: ['Ruby', 'Ruby on Rails API', 'VueJs', 'Bootstrap', 'Webpack', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] },
      { title: 'Tdb Thermicien', image: 'tdb-thermicien.jpg', url: 'http://tdb-thermicien.senova.fr/', description: 'projects.tdb_thermicien', technologies: ['Ruby', 'Ruby on Rails', 'Bootstrap', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery', 'Highcharts'] },
      { title: 'Todo en Único', image: 'todoenunico.jpg', url: '../assets/images/projects/todoenunico.jpg', description: 'projects.todoenunico', technologies: ['Material Design', 'Ruby', 'Ruby on Rails', 'jQuery'] },
      { title: 'UOrder', image: 'uorder.png', url: 'https://uorder.rappipage.com/', description: 'projects.uorder', technologies: ['Bootstrap', 'Ruby', 'Ruby on Rails', 'VueJs', 'PostgreSQL'] },
      { title: 'American Burger APP', image: 'american-burger-app.png', url: 'https://app.americanburger.com.co/', description: 'projects.american_burger_app', technologies: ['Material Design', 'Ruby', 'Ruby on Rails API', 'ReactJs', 'PostgreSQL'] },
      { title: 'TSirve.com', image: 'tsirve.png', url: 'https://tsirve.com/', description: 'projects.tsirve', technologies: ['Wordpress', 'Woocommerce', 'PHP', 'MySQL', 'HTML', 'JavaScript', 'CSS', 'jQuery'] }
    ]
  }),
  created () {
    this.images = require.context('../assets/images/projects/', false, /\.jpg$|\.png$/)
  },
  methods: {
    getImgUrl (name) {
      return this.images(`./${name}`)
    }
  }
}
</script>

<style scoped>
img {
  max-height: 631px !important;
  transition: transform .8s;
}

.project {
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.project img:hover {
  box-shadow: 0 7px 16px 0 rgba(187, 184, 184, 0.2);
  transform: translateY(10px);
}

.project:hover .info {
  bottom: 0px;
  opacity: 1;
}

.info {
  background-color: rgba(20, 133, 204, 0.8);
  color: white;
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  max-width: calc(100% - 30px);
  bottom: -100%;
  padding: 5px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  transition: .8s;
}
</style>
